import { storyblokEditable } from "@storyblok/react";

import Testimonial from "@components/molecules/Testimonials/partials/Testimonial";
import RichText from "@components/atoms/RichText";

import { TestimonialStoryblokProps } from "./types";

const TestimonialStoryblok: React.FC<TestimonialStoryblokProps> = ({
  blok
}) => {
  const { quotation } = blok;

  return (
    <Testimonial
      quote={<RichText content={quotation[0]?.text} />}
      {...storyblokEditable(blok)}
    />
  );
};

export default TestimonialStoryblok;
